/**
 * This type is the combination of workspace and company
 * The purpose of it is to remove the confusion between using company or workspaces
 * and have a unique type that covers both the workspaces and companies
 */

/** Defines the available options for opening the project. */
export let ProjectLaunchTarget = /*#__PURE__*/function (ProjectLaunchTarget) {
  /** Open the project in the Sphere Viewer */
  ProjectLaunchTarget["sphereViewer"] = "SphereViewer";
  /** Open the project in the WebEditor */
  ProjectLaunchTarget["webEditor"] = "WebEditor";
  return ProjectLaunchTarget;
}({});